import { Navigate } from "react-router-dom"
import Dashboard from "../pages/Dashboard";
import DashboardMain from "pages/Dashboard-blog";

// Auth
import Login from "pages/Authentication/login";
import Logout from "pages/Authentication/Logout";
import UserProfile from "pages/Authentication/User-profile";
import Notification from "pages/Authentication/Notification";
import ForgotPassword from "pages/Authentication/ForgotPassword";
import SignUp from "pages/Authentication/Register"
import PublicIndex from "pages/Public/Index";
import SettingsRoleIndex from "pages/SystemControl/Settings/Role/Index";
import DirectoryIndex from "pages/SystemControl/Directory/Index";
import MrWaterIndex from "pages/MainRegister/Water/Index";
import MrStaffIndex from "pages/MainRegister/Staff/Index";
import MrPersonEntity from "pages/MainRegister/PersonEntity/Index";
import SwNormalZoneIndex from "pages/SurfaceWater/NormalZone/Index";
import SwNormalZoneDetailIndex from "pages/SurfaceWater/NormalZoneDetail/Index"
import SwLakeIndex from "pages/SurfaceWater/Lake/Index";
import SwRiverIndex from "pages/SurfaceWater/River/Index";
import SwBulagIndex from "pages/SurfaceWater/Bulag/Index";
import SwIceRiverIndex from "pages/SurfaceWater/IceRiver/Index";
import SwHydrologyIndex from "pages/SurfaceWater/Hydrology/Index";
import SwQualityIndex from "pages/SurfaceWater/Quality/Index";
import SwTransportationIndex from "pages/SurfaceWater/Transportation/Index";
import UgDepositsIndex from "pages/UndergroundWater/Deposits/Index";
import UgWellIndex from "pages/UndergroundWater/Well/Index";
import UgHoleIndex from "pages/UndergroundWater/Hole/Index";
import UgRenewableSource from "pages/UndergroundWater/Renewable/Index";
import UgMainSource from "pages/UndergroundWater/MainSource/Index";
import UgStoneBelt from "pages/UndergroundWater/StoneBelt/Index";
import MiniralMain from "pages/Miniral/MiniralMain/Index";
import MiniralHealthArea from "pages/Miniral/HealthArea/Index";
import WaterBasinLine from "pages/WaterBasin/Line/Index";
import WaterBasinPicture from "pages/WaterBasin/Picture/Index";
import WaterBasinPlan from "pages/WaterBasin/Plan/Index";
import WorkReport from "pages/WaterBasin/WorkReport/Index";
import ConstCleaning from "pages/Construction/Cleaning/Index";
import ConstFloodDam from "pages/Construction/FloodDam/Index";
import ConstHydroelectric from "pages/Construction/Hydroelectric/Index";
import ConstPoolAndPond from "pages/Construction/PoolAndPond/Index";
import ConstIrrigation from "pages/Construction/Irrigation/Index";
import WaterUseFood from "pages/WaterUse/Food/Index";
import WaterUseAgriculture from "pages/WaterUse/Agriculture/Index";
import WaterUseEnergy from "pages/WaterUse/Energy/Index";
import WaterUseOrganization from "pages/WaterUse/Organization/Index";
import WaterUseMining from "pages/WaterUse/Mining/Index";
import WaterPollutionBigSource from "pages/WaterPollution/BigSource/Index";
import WaterPollutionMain from "pages/WaterPollution/Pollution/Index";
import ConsentMain from "pages/Consent/Index";
import ReportBox2_1 from "pages/Report/Box-2.1/Index";
import ReportBox2_2 from "pages/Report/Box-2.2/Index";
import ReportBox2_3 from "pages/Report/Box-2.3/Index";
import PublicMap from "pages/Public/Map/Index";
import MrDepartmentIndex from "pages/MainRegister/Department/Index";
import MrPositionIndex from "pages/MainRegister/Position/Index";
import SettingsMenuIndex from "pages/SystemControl/Settings/Menu/Index";
import SwLakeShow from "pages/SurfaceWater/Lake/Show";
import SettingsCommonDataIndex from "pages/SystemControl/Settings/Common/Index";
import SettingsMenuRole from "pages/SystemControl/Settings/Role/MenuRole";
import SettingsMenuPermissionIndex from "pages/SystemControl/Settings/menuPermission/Index";
import SwRiverShow from "pages/SurfaceWater/River/Show";
import SwSpringShow from "pages/SurfaceWater/Bulag/Show";
import SwIceRiverShow from "pages/SurfaceWater/IceRiver/Show";
import MineralShow from "pages/Miniral/MiniralMain/Show";
import ConstCleanShow from "pages/Construction/Cleaning/Show";
import ConstIrrigationShow from "pages/Construction/Irrigation/Show";
import ConstFloomDamShow from "pages/Construction/FloodDam/Show";
import ConstPoolAndPondShow from "pages/Construction/PoolAndPond/Show";
import ConstHydroelectricShow from "pages/Construction/Hydroelectric/Show";
import UgDepositsShow from "pages/UndergroundWater/Deposits/Show";
import UgWellShow from "pages/UndergroundWater/Well/Show";
import UgBoreholeShow from "pages/UndergroundWater/Hole/Show";


const authProtectedRoutes = [
  { path: "/dashboard", component: <Dashboard /> },
  { path: "/dashboard/main", component: <DashboardMain /> },
  { path: "/profile", component: <UserProfile /> },
  { path: "/notification", component: <Notification /> },

  // Системийн удирдлага
  { path: "/system/settings/role", component: <SettingsRoleIndex /> },
  { path: "/system/settings/menu", component: <SettingsMenuIndex /> },
  { path: "/system/settings/menu/permission", component: <SettingsMenuPermissionIndex /> },
  { path: "/system/settings/menu/role/:id", component: <SettingsMenuRole /> },
  { path: "/system/settings/common/data", component: <SettingsCommonDataIndex /> },
  { path: "/system/directory", component: <DirectoryIndex /> },

  // Үндсэн бүртгэл
  { path: "/main/water-register", component: <MrWaterIndex /> },
  { path: "/main/staff-register", component: <MrStaffIndex /> },
  { path: "/main/entity-register", component: <MrPersonEntity /> },
  { path: "/main/department-register", component: <MrDepartmentIndex /> },
  { path: "/main/position-register", component: <MrPositionIndex /> },

  // Гадаргын ус
  { path: "/surface/water/lake", component: <SwLakeIndex /> },
  { path: "/surface/water/lake/show/:id", component: <SwLakeShow /> },
  { path: "/surface/water/river", component: <SwRiverIndex /> },
  { path: "/surface/water/river/show/:id", component: <SwRiverShow /> },
  { path: "/surface/water/bulag", component: <SwBulagIndex /> },
  { path: "/surface/water/bulag/show/:id", component: <SwSpringShow /> },
  { path: "/surface/water/ice-river", component: <SwIceRiverIndex /> },
  { path: "/surface/water/ice-river/show/:id", component: <SwIceRiverShow /> },
  { path: "/surface/water/normal-zone", component: <SwNormalZoneIndex /> },
  { path: "/surface/water/normal-zone/detail", component: <SwNormalZoneDetailIndex /> },

  { path: "/surface/water/hydrology", component: <SwHydrologyIndex /> },
  { path: "/surface/water/quality", component: <SwQualityIndex /> },
  { path: "/surface/water/transportation", component: <SwTransportationIndex /> },

  // Газрын доорх ус
  { path: "/under/ground/water/deposits", component: <UgDepositsIndex /> },
  { path: "/under/ground/water/deposits/show/:id", component: <UgDepositsShow /> },
  { path: "/under/ground/water/well", component: <UgWellIndex /> },
  { path: "/under/ground/water/well/show/:id", component: <UgWellShow /> },
  { path: "/under/ground/water/hole", component: <UgHoleIndex /> },
  { path: "/under/ground/water/hole/show/:id", component: <UgBoreholeShow /> },
  { path: "/under/ground/renewable/resources", component: <UgRenewableSource /> },
  { path: "/under/ground/main/source", component: <UgMainSource /> },
  { path: "/under/ground/stone/belt", component: <UgStoneBelt /> },

  // Рашаан
  { path: "/rashaan/index", component: <MiniralMain /> },
  { path: "/rashaan/show/:id", component: <MineralShow /> },

  { path: "/rashaan/health/area", component: <MiniralHealthArea /> },

  // Усны барилга байгууламж
  { path: "/water/basin/line", component: <WaterBasinLine /> },
  { path: "/water/basin/picture", component: <WaterBasinPicture /> },
  { path: "/water/basin/plan", component: <WaterBasinPlan /> },
  { path: "/water/basin/work/report", component: <WorkReport /> },

  // Усны барилга байгууламж
  { path: "/construction/water/cleaning", component: <ConstCleaning /> },
  { path: "/construction/water/cleaning/show/:id", component: <ConstCleanShow /> },

  { path: "/construction/water/irrigation", component: <ConstIrrigation /> },
  { path: "/construction/water/irrigation/show/:id", component: <ConstIrrigationShow /> },

  { path: "/construction/water/flood/dam", component: <ConstFloodDam /> },
  { path: "/construction/water/flood/dam/show/:id", component: <ConstFloomDamShow /> },

  { path: "/construction/water/pool/and/pond", component: <ConstPoolAndPond /> },
  { path: "/construction/water/pool/and/pond/show/:id", component: <ConstPoolAndPondShow /> },

  { path: "/construction/water/hydroelectric/station", component: <ConstHydroelectric /> },
  { path: "/construction/water/hydroelectric/station/show/:id", component: <ConstHydroelectricShow /> },


  // Ус ашиглалт
  { path: "/water/use/food", component: <WaterUseFood /> },
  { path: "/water/use/agriculture", component: <WaterUseAgriculture /> },
  { path: "/water/use/energy", component: <WaterUseEnergy /> },
  { path: "/water/use/organization", component: <WaterUseOrganization /> },
  { path: "/water/use/mining", component: <WaterUseMining /> },

  // Ус ашиглалт
  { path: "/water/pollution/main", component: <WaterPollutionMain /> },
  { path: "/water/pollution/big/source", component: <WaterPollutionBigSource /> },

  // Зөвшөөрөл
  { path: "/consent/index", component: <ConsentMain /> },

  // Тайлан 
  { path: "/report/box-2.1", component: <ReportBox2_1 /> },
  { path: "/report/box-2.2", component: <ReportBox2_2 /> },
  { path: "/report/box-2.3", component: <ReportBox2_3 /> },



  // { path: "/", exact: true, component: <Navigate to="/dashboard" /> },
];

const publicRoutes = [
  { path: "/login", component: <Login /> },
  // { path: "/logout", component: <Logout /> },
  // { path: "/forgot-password", component: <ForgotPassword /> },
  // { path: "/register", component: <SignUp /> },
  { path: "/", component: <Login /> },

  // Нээлттэй мэдээлэл MAP
  // { path: "/public/map", component: <PublicMap /> },




]
export { authProtectedRoutes, publicRoutes };
